// extracted by mini-css-extract-plugin
module.exports = {"boxWrap":"purify_index__boxWrap--3o1vD","content":"purify_index__content--3tBo7","sectionTitle":"purify_index__sectionTitle--3BzRN"};